export default __webpack_public_path__ + "static/media/logo.241ddd6b.png";